type userType = {
	firstName: string | null | undefined
	lastName: string | null | undefined
}
export const transformNameToInitialName = (user: userType): string => {
	const firstLetterFirstName = user?.firstName?.[0] || ''
	const firstLetterLastName = user?.lastName?.[0] || ''
	return `${firstLetterFirstName}${firstLetterLastName}`.toUpperCase()
}
